import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { setUser } from "../features/userSlice";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import C_Navbar from "./C_Navbar"; // ✅ 加入這行

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userInfo);

  useEffect(() => {
    if (!user) {
      const saved = localStorage.getItem("token");
      if (saved) {
        try {
          const { token } = JSON.parse(saved);
          const decoded = jwtDecode(token);

          const isExpired = decoded.exp * 1000 < Date.now(); // JWT exp 是秒，要乘1000變成毫秒

          if (isExpired) {
            console.warn("⏰ token 已過期，登出中...");
            localStorage.removeItem("token");
            navigate("/", { replace: true });
            return;
          }

          if (decoded && decoded.email && decoded.name) {
            dispatch(setUser({ ...decoded, token }));
            return;
          }
        } catch (err) {
          console.warn("❌ token 無效，將導向 /");
        }
      }

      navigate("/", { replace: true });
    }
  }, [user, dispatch, navigate]);

  return (
    <section className="home">
      <C_Navbar /> {/* ✅ 放在頁面最上方 */}
      <h1 className="home-title">
        {user ? `👋 歡迎 ${user.name} 回到系統！` : "請先登入..."}
      </h1>
      <p className="home-subtitle">
        {user?.email && `您登入的帳號是：${user.email}`}
      </p>
    </section>
  );
};

export default Home;
